export const EmptyTable = () => {
    return <div className="blockBody"></div>
}